import {CountriesHelper} from './countries';

export const findPhonePrefix = (
  value: string,
  selectedCountry: string[] | undefined,
  countryHelper: CountriesHelper,
) => {
  let countries: string[][] = [];
  let prevCountries: string[][] = [];

  let newPhonePrefix;
  let i = 1;

  do {
    i++;
    newPhonePrefix = value.substr(0, i);

    if (countries.length) {
      prevCountries = countries;
    }

    countries = countryHelper.searchByPrefix(newPhonePrefix, true);
  } while (value.length >= i);

  if (prevCountries.length && selectedCountry && prevCountries.indexOf(selectedCountry) !== -1) {
    newPhonePrefix = selectedCountry[3];
  } else if (prevCountries.length) {
    newPhonePrefix = prevCountries[0][3];
  } else {
    newPhonePrefix = '';
  }

  return newPhonePrefix;
};

export const findCountry = (
  phonePrefix: string,
  selectedCountry: string[] | undefined,
  countryHelper: CountriesHelper,
) => {
  let countries = countryHelper.searchByPrefix(phonePrefix, true);
  if (countries.length && selectedCountry && countries.indexOf(selectedCountry) !== -1) {
    return selectedCountry;
  } else if (countries.length) {
    return countries[0];
  }
};

export const findPhoneNumber = (value: string, phonePrefix: string): string => {
  return value.replace(phonePrefix, '');
};

export const formatPhone = (phoneNumber: string): string => {
  if (phoneNumber.length <= 6) {
    return phoneNumber.replace(/(\d{3})(\d{1})/, '$1 $2');
  } else if (phoneNumber.length < 8) {
    return phoneNumber.replace(/(\d{2})(\d{2})(\d{1})/, '$1 $2 $3');
  }
  return phoneNumber.replace(/(\d{3})(\d{3})(\d{1})/, '$1 $2 $3');
};
